module.exports = __webpack_public_path__ + "img/41.78cde8be.jpg";